<template>
  <Layout :company="model">
		<div class="text-center loaderko" v-if="loading">
			<div class="spinner-grow text-primary m-2" role="status">
				<span class="sr-only">Loading...</span>
			</div>
			<div class="text-muted small">Loading</div>
		</div>
		<div class="card mt-4 text-center p-4 picker-container">
			<div class="h5 m-0">Candidate: {{application.candidate_id.full_name}}</div>
			<div class="h6 text-muted">Role for {{application.job_id.title}}</div>
			<hr>
			<div class="text-muted" v-if="application.confirmed_schedule">
				Thank you for confirming your availability.
			</div>

			<div class="text-muted" v-if="application.reschedule">
				You request for reschedule is now on process.
			</div>

			<div v-if="!application.confirmed_schedule && !application.reschedule">
				<div class="h6 mb-3 text-muted">
					Please choose availability date for your interview
				</div>
				<div class="h6 text-muted">{{getTimezone.text}}</div>
				<div class="text-muted mr-3"><b>Location:</b> {{application.location || 'N/A'}}</div>
				<div class="text-muted"><b>Interview Type:</b> {{application.interview_type || 'N/A'}}</div>
				<hr>
				<div class="row mt-3">
					<div class="col-md-7">
						<flat-pickr
							v-model="model.date"
							class="form-control flatpicker"
							@on-change="selectDate"
							hidden
							:config="options"
						></flat-pickr>
					</div>

					<div class="col-md-5">
						<b-form-group label="Available Time Slots">
							<div class="text-muted" v-if="times.length == 0">
								No slot/s available
							</div>
							<b-form-radio-group
								v-if="times.length > 0"
								v-model="model.time"
								:options="times"
								buttons
								class="btn-block"
								name="radios-btn-default"
								button-variant="outline-primary"
								size="md"
								stacked
								@change="timeChange"
							></b-form-radio-group>
						</b-form-group>
					</div>
				</div>
				<div class="mt-3">
					<span>You've selected: </span> <span class="h6 font-weight-bold">{{(model.date || false) | date}}</span>
					<div class="text-muted">Time of Interview: </div> <span class="h6 font-weight-bold">{{ start_time || 'N/A' }} - {{ end_time || 'N/A'}}</span> 
				</div>
				<button class="btn2 btn2-primary btn2-md btn-block mt-3" 
					@click="onProceed"
				><i class="uil uil-message"></i> Proceed</button>
				<button 
					@click="onResched"
				class="btn btn-danger btn-block mt-3"><i class="uil uil-question-circle"></i> Ask for Re-Schedule</button>
			</div>
		</div>
		<ScheduleModal :reSched="true" :uiid="application.uiid" :timesData="[]" @onClickOk="onClickSchedule" :settings="settings" :application="application"/>
  </Layout>
</template>

<script>
import Layout from '@layouts/basic'
import { mapActions } from 'vuex'
import moment from 'moment/moment'
import  FormMixin from '@mixins/form'
import ScheduleModal from '@components/modals/scheduleModal'
import timezone from '@src/data/timezone.json'

export default {
	mixins:[FormMixin],
	components: { Layout, ScheduleModal },
	name: 'Login',
	data() {
		return {
			timezone_option:timezone,
			uiid:'',
			model:{
				date:'',
				time:'',
				selected:''
			},
			times: [],
			selected_times:{},
			application:{
				candidate_id:{},
				job_id:{}
			},
			start_time:'',
			end_time:'',
			dates:[],
			settings:{},
			options:{
				inline:true,
				enable:[]
			}
		}
	},
	computed:{
		getTimezone(){
			var timez =  this.timezone_option.filter((el)=>{return el.value == this.application.timezone})
			if(timez.length == 1){
				timez = timez[0]
			}
			return timez
		}
	},
	methods:{
		...mapActions('candidate', ['getScheduledInterviewByToken', 'confirmSchedule', 'reSchedule']),
		selectDate(a, b){
			this.start_time = ''
			this.end_time = ''
			this.times = []
			this.selected_times = {}
			let initial = true
			for(var key in this.dates){
				if(moment(this.dates[key].date).format('YYYY-MM-DD') == b){
					for(var _key in this.dates[key]['times']){
						var x = this.dates[key]['times'][_key]
						var _time = {
							_id:x._id,
							start_time:x.start_time,
							end_time:x.end_time,
							text:x.start_time + ' - ' + x.end_time,
							value:x._id
						}

						this.selected_times[x._id] = _time

						this.times.push(_time)
						if(initial){
							//this.model.time = x._id
							this.timeChange(x._id)
							this.model.time = x._id
							/* this.start_time = x.start_time
							this.end_time = x.end_time
							this.model.time = x._id */
							initial = false
						}
					}
				}
			}
		},
		timeChange(val){
			let data = this.selected_times[val]
			this.start_time = data['start_time']
			this.end_time = data['end_time']
			this.model.selected = data
		},
		onProceed(){
			if(!this.model.date){
				this.$bvToast.toast(`Please select a date to proceed!`, {
					title: 'Notification',
					variant:'danger'
				})
				return false
			}
			let date = moment(this.model.date).format('MMM DD, YYYY')
			this.$bvModal.msgBoxConfirm(
				`Are you sure you want to proceed with your selected date ${date} (${this.start_time} - ${this.end_time}) ?`, 
			{
        title: 'Please Confirm Action',
        size: 'md',
        buttonSize: 'sm',
        okVariant: 'success',
        okTitle: 'PROCEED',
        cancelTitle: 'CANCEL',
        footerClass: 'p-2',
        hideHeaderClose: false,
        centered: true
      }).then(res => {
        if(res == true){
					this.toggleLoading()
					this.confirmSchedule({
						id:this.model.selected._id
					}).then(res => {
						if(res.data){
							this.$bvToast.toast(`Successfully confirmed.`, {
								title: 'Notification',
								variant:'success'
							})
							this.application = res.data
						}
						this.toggleLoading()
					})
        }
      })
		},
		onClickSchedule(times){
			
			this.$bvModal.msgBoxConfirm('Are you sure you want to suggest / re-schedule your interview?', {
        title: 'Please Confirm Action',
        size: 'sm',
        buttonSize: 'sm',
        okVariant: 'danger',
        okTitle: 'CONFIRM',
        cancelTitle: 'CANCEL',
        footerClass: 'p-2',
        hideHeaderClose: false,
        centered: true
      }).then(res => {
        if(res == true){
					this.toggleLoading()

					this.reSchedule({
						id:this.application._id,
						times:times
					}).then(res => {
						if(res.data){
							this.$bvToast.toast(`Your request for re-schedule has been sent.`, {
								title: 'Notification',
								variant:'success'
							})
							this.application = res.data
							this.$nextTick(() => {
								this.$bvModal.hide('schedule-modal')
							})
						}
						this.toggleLoading()
					})

        }
      })
		},
		onResched(){
      this.$bvModal.show('schedule-modal')
			/*  */
		},
	},
	filters:{
    date:function(v){
      return v ? moment(v).format('MMM DD, YYYY') : 'N/A'
    }
  },
	async beforeMount() {
		await this.getScheduledInterviewByToken(this.$route.query.key).then(res => {
			if(res.data.application){
				this.dates = res.data.schedules.sort((a, b) => new Date(a.date) - new Date(b.date)) 
				this.application = res.data.application
				this.settings = res.data.settings
				this.options.enable = res.data.schedules.map(e => moment(e.date).format('YYYY-MM-DD')).join(", ").split(", ") /* res.data.sort((a, b) => new Date(a.date) - new Date(b.date))  */
			}else{
				this.$router.push('/')
			}
		})
	}
}
</script>

<style lang="scss">
.picker-container{
	width:600px;
	margin:auto
}
@media screen and (max-width: 650px){
  .picker-container{
		width:100%;
  }
}
.flatpickr-calendar{
	margin:auto;
}
.flatpickr-disabled{
	color: #dfdfdf !important;
	font-weight: normal !important;
}
.flatpickr-day{
	color: green;
	font-weight: 900;
}
.loaderko{
  position: absolute;
  height: 100%;
  z-index: 9;
  background: #ffffffc7;
  width: 100%;
  /* vertical-align: middle; */
  /* margin: auto; */
}
</style>

